import { useEffect, useState } from "react";

interface ApiResponse {
    success: boolean,
    dateUtc: string,
    keysWithoutSummaryCount: number,
    keysWithoutSummary: string[],
    keysTotal: number
}

export default function useHealthAPI() {

    const [loading, setLoading] = useState(false)
    const [error, setError] = useState<string | null>(null)
    const [scannerHealth, setScannerHealth] = useState<ApiResponse | null>(null)

    async function fetchScannerHealth() {
        setLoading(true)
        setError(null)

        const api_url = process.env.REACT_APP_API_SERVER_URL
        const api_version = process.env.REACT_APP_API_VERSION

        try {
            const res = await fetch(`${api_url}/api/${api_version}/health/scanners`,
                {
                    credentials: 'include',
                }
            )

            if (!res.ok) {
                throw new Error(`Request failed with status ${res.status}`)
            }

            const apiResponse: ApiResponse = await res.json()

            setScannerHealth(apiResponse);
        } catch (e) {
            setError(e instanceof Error ? e.message : 'Failed to fetch scanner health')
        } finally {
            setLoading(false)
        }
    }

    useEffect(() => {
        fetchScannerHealth()
    }, [])

    return { loading, error, fetchScannerHealth, scannerHealth }
}
